import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  height: 100%;

  .dashboard {
    margin-left: 250px;
    width: calc(100% - 250px);

    @media (max-width: 991px) {
      margin-left: 0;
      width: 100%;
    }

    main {
      margin-top: 66px;
      padding: 30px;
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/Base/styles.js